export const appName = "ZagrajMi"
export const eventTypeLabels = {
  TYPE_KARAOKE: 'Karaoke',
  TYPE_STANDARD: 'Dance party/concert',
  TYPE_STANDARD_CLOSED: 'Dance party/concert (closed list)',
};

// Domyślna przezroczystość tła paska wydarzenia, gdy event jej nie ustawił.
// Musi być zgodna z .bg-color-primary-subtle w custom.scss.
export const defaultColorOpacity = 0.1;

export const typeKaraoke = 'TYPE_KARAOKE';
export const typeStandard = 'TYPE_STANDARD';
export const typeStandardClosed = 'TYPE_STANDARD_CLOSED';
